import { LayoutService } from 'src/app/layout/layout.service';
import { Component, OnInit } from '@angular/core';
import { App } from 'src/app/models/app';
import * as g from '../../../globals';
@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.less'],
})
export class IndexComponent implements OnInit {
  app: App;
  constructor(private layoutService: LayoutService) { }

  ngOnInit(): void {
    g.appUrlPrefix('');
    this.layoutService.getApp(4).subscribe((d: any) => {
      this.app = {
        id: d.Code,
        baseUrl: d.IndexUrl,
        description: d.Description,
        icon: '',
        parentMenuId: d.RootMenu,
        name: d.Name,
        menus: []
      };
    });
  }
}
